import React from 'react';
import { Box, Typography } from '@mui/material';

/** Get emoji icon for file extension */
export const getFileIcon = (extension: string): string => {
  const ext = extension.toLowerCase();
  if (['.pdf'].includes(ext)) return '📄';
  if (['.doc', '.docx'].includes(ext)) return '📝';
  if (['.xls', '.xlsx'].includes(ext)) return '📊';
  if (['.png', '.jpg', '.jpeg', '.gif'].includes(ext)) return '🖼️';
  if (['.txt'].includes(ext)) return '📋';
  return '📎';
};

interface FileIconProps {
  extension: string;
}

/**
 * Displays file type emoji icon.
 */
export const FileIcon: React.FC<FileIconProps> = ({ extension }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', py: 0.5 }}>
    <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
      {getFileIcon(extension)}
    </Typography>
  </Box>
);

/** Syncfusion grid template wrapper */
export const fileIconTemplate = (props: { extension?: string; iconEmoji?: string }) => (
  <FileIcon extension={props.extension || ''} />
);

export default FileIcon;
